export const maritalStatusList = [
  {Id: '1', Name: 'Never Married'},
  {Id: '2', Name: 'Awaiting Divorce'},
  {Id: '3', Name: 'Divorced'},
  {Id: '4', Name: 'Widowed'},
  {Id: '5', Name: 'Annulled'},
];
